export default __webpack_public_path__ + "static/media/Ies_Signify.2646fbdb.png";